import PersonalPage from '@/shared/publish/MyPublications/ClassLists/PersonalPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/publish/MyPublications/ClassLists/PersonalPage',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <PersonalPage />
}
